import React, { useState } from 'react'
import { ArrowRight, Info } from 'lucide-react'

function Step1VcnCount({ initialCount, onComplete }) {
  const [vcnCount, setVcnCount] = useState(initialCount)
  const [error, setError] = useState('')

  const handleCountChange = (e) => {
    const value = parseInt(e.target.value, 10)
    if (!isNaN(value)) {
      if (value < 1) {
        setVcnCount(1)
      } else if (value > 10) {
        setVcnCount(10)
      } else {
        setVcnCount(value)
      }
      setError('')
    }
  }

  const handleContinue = () => {
    if (vcnCount < 1 || vcnCount > 10) {
      setError('Please enter a number between 1 and 10')
      return
    }
    onComplete(vcnCount)
  }

  return (
    <div className="step-card">
      <div className="step-header">
        <h2>How many VCNs do you need?</h2>
        <p className="step-description">
          Configure the number of Virtual Cloud Networks for your OCI architecture
        </p>
      </div>

      <div className="step-content">
        <div className="vcn-count-section">
          <label className="input-label">Number of VCNs</label>
          <div className="number-input-wrapper">
            <button
              className="number-btn"
              onClick={() => setVcnCount(Math.max(1, vcnCount - 1))}
            >
              −
            </button>
            <input
              type="number"
              className="number-input"
              value={vcnCount}
              onChange={handleCountChange}
              min="1"
              max="10"
            />
            <button
              className="number-btn"
              onClick={() => setVcnCount(Math.min(10, vcnCount + 1))}
            >
              +
            </button>
          </div>
          <span className="help-text">Maximum 10 VCNs</span>
        </div>

        {error && (
          <div className="error-message">
            <Info size={16} />
            {error}
          </div>
        )}

        <div className="info-box">
          <h3>What is a VCN?</h3>
          <p>
            A Virtual Cloud Network (VCN) is a software-defined network in OCI.
            Each VCN can contain multiple subnets and is isolated from other VCNs
            by default. You'll configure subnets and base CIDR ranges in the next steps.
          </p>
        </div>
      </div>

      <div className="step-footer">
        <button className="btn btn-primary btn-large" onClick={handleContinue}>
          Continue to Subnet Configuration
          <ArrowRight size={18} />
        </button>
      </div>
    </div>
  )
}

export default Step1VcnCount
